import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Appearance } from 'react-native';

interface ThemeState {
  /** Dark mode enabled */
  isDark: boolean;

  setIsDark: (value: boolean) => void;
  toggleTheme: () => void;
  resetTheme: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      isDark: Appearance.getColorScheme() === 'dark',

      setIsDark: (value) => set({ isDark: value }),

      toggleTheme: () =>
        set((state) => ({ isDark: !state.isDark })),

      resetTheme: () =>
        set({
          isDark: Appearance.getColorScheme() === 'dark',
        }),
    }),
    {
      name: 'theme-store', // AsyncStorage key
      storage: createJSONStorage(() => AsyncStorage),
      version: 1,
    }
  )
);
